




































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Contacts extends Vue { 
    @Prop(Object) readonly tableItem: object | undefined | any
    menu = false

    get dateText() {
      	if (this.tableItem.expectTranMonth) {
			const monthText = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'] 
			const [year, month] = this.tableItem.expectTranMonth.split("-")
			return `${monthText[parseInt(month)]}-${year}`
		}
		return this.tableItem.expectTranMonth
    }

}
